import React, { InputHTMLAttributes } from 'react'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string
    subtext?: string
    isBlock?: boolean
}

const Checkbox: React.FC<InputProps> = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className = '', label, name, subtext, isBlock = false, disabled = false, ...restProps }, ref) => {
        return (
            <div className="flex">
                <div className="flex items-center">
                    <input
                        ref={ref}
                        id={name}
                        name={name}
                        type="checkbox"
                        disabled={disabled}
                        className={`h-6 w-6 text-crusta-500 border-gray-300 rounded hover:cursor-pointer
						${className}
					`}
                        {...restProps}
                    />
                </div>
                {label && (
                    <div className="ml-3 text-base w-full">
                        <label
                            htmlFor={name}
                            className={`font-medium text-gray-500 hover:cursor-pointer ${isBlock ? 'block' : ''}`}
                        >
                            {label}
                        </label>

                        {subtext && <p className="text-gray-500">{subtext}</p>}
                    </div>
                )}
            </div>
        )
    }
)

export default Checkbox
